import { Text } from '@airwallex/typography';
import React from 'react';
import { VStack } from '@airwallex/stacks';
import { TotalRow, Divider } from './style';
import { useTranslation } from 'react-i18next';
import { useTabletOrMobile } from '@/hooks/useMediaQuery';

const TotalSection: React.FC<{ totals: { label: string; value: string }[] }> = ({ totals }) => {
  const { t } = useTranslation();
  const isTabletOrMobile = useTabletOrMobile();

  return (
    <VStack space="8px" style={{ marginTop: '16px' }}>
      {totals.map((total, index) => (
        <React.Fragment key={index}>
          {index === totals.length - 1 && (
            <TotalRow>
              <Divider />
            </TotalRow>
          )}
          <TotalRow>
            <Text variant={index === totals.length - 1 ? 'headline400' : 'body'}>{total.label}</Text>
            <Text variant={index === totals.length - 1 ? 'headline400' : 'body'}>{total.value}</Text>
          </TotalRow>
        </React.Fragment>
      ))}
    </VStack>
  );
};

export default TotalSection;
